import cn from 'classnames';
import React from 'react';
// import { useAdaptedComponents } from '../../hooks/useAdaptedComponents';
import { ButtonProps } from './types';
import * as s from './styles.scss';

export const Button: React.FunctionComponent<ButtonProps> = ({
  size = 'medium',
  fullWidth,
  filled,
  noBorder,
  disabled,
  autoFocus,
  children,
  dataHook,
  title,
  onClick,
}) => {
  // TODO: temporary disable adapted component for Button
  // const AdaptedComponents = useAdaptedComponents();

  // if (AdaptedComponents) {
  //   return (
  //     <AdaptedComponents.Button
  //       title={title}
  //       onClick={onClick}
  //       size={size}
  //       disabled={disabled}
  //       autoFocus={autoFocus}
  //       dataHook={dataHook}
  //       fullWidth={fullWidth}
  //     >
  //       {children}
  //     </AdaptedComponents.Button>
  //   );
  // }

  return (
    <button
      className={cn(s.root, s[size], {
        [s.filled]: filled,
        [s.fullWidth]: fullWidth,
        [s.noBorder]: noBorder,
      })}
      data-hook={dataHook}
      disabled={disabled}
      autoFocus={autoFocus}
      title={title || typeof children === 'string' ? (children as string) : ''}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
Button.displayName = 'Button';
